import { render, staticRenderFns } from "./OpenMarketSortFilter.vue?vue&type=template&id=11cdf271&scoped=true"
import script from "./OpenMarketSortFilter.vue?vue&type=script&lang=js"
export * from "./OpenMarketSortFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cdf271",
  null
  
)

export default component.exports